import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Weddings.css';
import { Link } from 'react-router-dom';

function Weddings() {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [
    { src: "/images/GAwedding/GAwedding-2.jpg", alt: "wedding 1" },
    { src: "/images/GAwedding/GAwedding-8.jpg", alt: "wedding 2" },
    { src: "/images/GAwedding/GAwedding-11.jpg", alt: "wedding 3" },
    { src: "/images/DDwedding/DDwedding-11.jpg", alt: "wedding 4" },
    { src: "/images/DDwedding/DDwedding-2.jpg", alt: "wedding 5" },
    { src: "/images/DDwedding/DDwedding-8.jpg", alt: "wedding 6" }
  ];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (selectedImage === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
      if (e.key === 'ArrowRight') handleNextImage();
      if (e.key === 'ArrowLeft') handlePrevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, images]);

  return (
    <div className="weddings-section">
      <Helmet>
        <title>Wedding Photography & Videography - Szakacs Visuals</title>
        <meta name="description" content="Professional wedding photography and videography services in Bristol. Capture your special day with our expert team. Book your wedding package today." />
        <meta name="keywords" content="wedding photography Bristol, wedding videography, South West UK wedding photographer, documentary wedding photography, Bristol wedding videographer" />
        <meta property="og:title" content="Wedding Photography & Videography - Szakacs Visuals" />
        <meta property="og:description" content="Professional wedding photography and videography services in Bristol. Capture your special day with our expert team. Book your wedding package today." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/services/weddings" />
        <meta property="og:image" content="https://szakacsvisuals.co.uk/og-cover.jpg" />
        <meta property="og:image:alt" content="Szakacs Visuals Wedding Photography" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/services/weddings" />
      </Helmet>
      <div className="header-img-container">
        <img className="header-img" src="/images/GAwedding/GAwedding-8.jpg" alt="Weddings header" />
        <div className="header-img-overlay">
          <h1 className="header-title-mobile">Weddings</h1>
          <p>Your special day deserves nothing but perfection. Let me help you create unforgettable memories with our exceptional wedding services.</p>
        </div>
      </div>
      <h1 style={{display:'none'}}>Weddings</h1>
      <p style={{display:'none'}}>Beautiful wedding photography and videography to capture your special day.</p>
      <div className="gallery-grid-weddings">
        {images.map((image, index) => (
          <img key={index} className="gallery-img" src={image.src} alt={image.alt} onClick={() => handleImageClick(index)} />
        ))}
      </div>
      {selectedImage !== null && (
        <div className="album-modal-overlay" onClick={handleCloseModal}>
          <div className="album-modal" onClick={(e) => e.stopPropagation()}>
            <button className="album-close-btn" onClick={handleCloseModal}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={handlePrevImage}>&#8592;</button>
            <img className="album-image" src={images[selectedImage].src} alt={images[selectedImage].alt} />
            <button className="album-arrow album-arrow-right" onClick={handleNextImage}>&#8594;</button>
            <div className="album-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === selectedImage ? 'album-dot active' : 'album-dot'}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {/* Pricing Plan Section */}
      <div className="pricing-plan-section">
        <div className="pricing-plan-grid">
          <div className="pricing-card">
            <img className="pricing-card-img" src="/images/GAwedding/GAwedding-8.jpg" alt="Ceremony Package" />
            <div className="pricing-card-title">Ceremony Package</div>
            <div className="pricing-card-details">3 hr</div>
            <div className="pricing-card-price">£399</div>
            <Link to="/contact" className="pricing-card-btn">Book Now</Link>
          </div>
          <div className="pricing-card">
            <img className="pricing-card-img" src="/images/GAwedding/GAwedding-15.jpg" alt="Engagement Photoshoot" />
            <div className="pricing-card-title">Wedding Videography</div>
            <div className="pricing-card-details">Full Day</div>
            <div className="pricing-card-price">£899</div>
            <Link to="/contact" className="pricing-card-btn">Book Now</Link>
          </div>
          <div className="pricing-card">
            <img className="pricing-card-img" src="/images/DDwedding/DDwedding-8.jpg" alt="Wedding Photography" />
            <div className="pricing-card-title">Wedding Photography</div>
            <div className="pricing-card-details">Full Day</div>
            <div className="pricing-card-price">£899</div>
            <Link to="/contact" className="pricing-card-btn">Book Now</Link>
          </div>
        </div>
      </div>
      <div className="gallery-cta">
        <h1>Wedding Photography and Videography in Bristol, Wales & the South West</h1>
        <p>Your wedding day is full of real, beautiful moments — and we're here to capture them all. Based in Bristol and covering Wales, Somerset, Gloucestershire, and the South West UK, we specialize in natural, documentary-style wedding photography that tells your love story with authenticity and emotion.

From intimate elopements to full-day celebrations, we focus on candid moments, meaningful details, and the joy that fills your day. Our approach is relaxed, unobtrusive, and always tailored to you — ensuring you feel comfortable and confident in front of the camera.

Whether you're planning a rustic countryside wedding in Somerset, a seaside celebration in South Wales, or a modern city ceremony in Bristol, we're here to create stunning images you'll treasure for a lifetime.

Let's turn your wedding day into art.</p>
        <Link to="/contact" className="gallery-cta-btn">Book Now</Link>
      </div>
    </div>
  );
}

export default Weddings; 